import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class ConnectionInfo {
    @jsonMember(String)
    time?: string
    @jsonMember(Number)
    connected?: number
}
